import { render, staticRenderFns } from "./SettingsValue.vue?vue&type=template&id=1c8a2722&"
import script from "./SettingsValue.vue?vue&type=script&lang=js&"
export * from "./SettingsValue.vue?vue&type=script&lang=js&"
import style0 from "./SettingsValue.vue?vue&type=style&index=0&id=1c8a2722&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports